export const MaritalStatus = {
  SINGLE: "single",
  MARRIED: "married",
  DIVORCED: "divorced"
} as const;

export type TMaritalStatus = (typeof MaritalStatus)[keyof typeof MaritalStatus];
